import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import FunctionalButton from "../FunctionalButton";
import AccessIcon from "../icons/AccessIcon";
import isNullOrUndefined from "../../tools/isNullOrUndefined";
function InformationPreGameComponent(props) {
    const [counter, setCounter] = useState(props.counter);
    const [counterEnded, setCounterEnded] = useState(props.counterEnded);
    let timer;
    function updateCounter() {
        if (counterEnded) {
            clearInterval(timer);
            return;
        }
        timer = setInterval(() => {
            setCounter((prevCounter) => isNullOrUndefined(prevCounter) ? 0 : prevCounter - 1);
            console.log(counter);
            if (counter === 0) {
                setCounterEnded(true);
                clearInterval(timer);
            }
        }, 1000);
    }
    function secondsToHms(s) {
        let minuteString = "";
        let secondString = "";
        let m = Math.floor((s % 3600) / 60);
        let s1 = Math.floor((s % 3600) % 60);
        if (s1 < 10)
            secondString = `0${s1}`;
        else
            secondString = `${s1}`;
        if (m < 10)
            minuteString = `0${m}`;
        else
            minuteString = `${m}`;
        return `${minuteString}:${secondString}`;
    }
    // useEffect(() => {
    //     updateCounter();
    //     console.log('counter', counter);
    //     return () => clearInterval(timer);
    // }, [counter])
    const timerRef = useRef(null);
    useEffect(() => {
        // If no counter provided, do not start a timer and do not show countdown/button
        if (counter === undefined || counterEnded === undefined)
            return;
        // If already ended, ensure interval is cleared
        if (counterEnded) {
            if (timerRef.current)
                clearInterval(timerRef.current);
            timerRef.current = null;
            return;
        }
        // Start interval once
        if (!timerRef.current) {
            timerRef.current = setInterval(() => {
                setCounter((prev) => {
                    if (prev === undefined)
                        return prev;
                    const next = prev - 1;
                    if (next <= 0) {
                        setCounterEnded(true);
                        // clear here
                        if (timerRef.current)
                            clearInterval(timerRef.current);
                        timerRef.current = null;
                        return 0;
                    }
                    return next;
                });
            }, 1000);
        }
        return () => {
            if (timerRef.current)
                clearInterval(timerRef.current);
            timerRef.current = null;
        };
    }, [counter, counterEnded]);
    return (_jsxs("div", Object.assign({ className: "flex flex-col w-full", style: {
            minHeight: "91px",
            height: "91px",
        } }, { children: [_jsxs("div", Object.assign({ className: "flex h-[89px] w-full justify-between items-center" }, { children: [_jsx("div", Object.assign({ className: "flex font-roboto text-white", style: {
                            fontSize: "30px",
                            fontWeight: "900",
                            textTransform: "uppercase",
                            lineHeight: "35px",
                            fontStyle: "normal",
                        } }, { children: props.sessionName })), counterEnded && counterEnded !== undefined && (_jsx("div", Object.assign({ style: {
                            border: "2px solid #000000",
                            zIndex: 100,
                        } }, { children: _jsx(FunctionalButton, { onClick: props.onClickButton, enabled: props.buttonActive, text: props.textButton, colorMode: 0, isRound: false, icon: AccessIcon, showLeftIcon: true }) }))), !counterEnded && counterEnded !== undefined && (_jsxs("div", Object.assign({ className: "flex gap-4" }, { children: [_jsx("div", Object.assign({ className: "flex font-roboto text-white self-center text-end", style: {
                                    width: "73px",
                                    minWidth: "73px",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                    lineHeight: "14px",
                                } }, { children: "D\u00E9but de la session dans" })), _jsx("div", Object.assign({ className: "flex font-roboto text-white", style: {
                                    fontSize: "36px",
                                    fontWeight: "700",
                                    lineHeight: "42px",
                                } }, { children: secondsToHms(counter) }))] })))] })), _jsx("img", { src: "/assets/UI/line.png", alt: "", className: "flex w-full h-[2px]" })] })));
}
export default InformationPreGameComponent;
